<div class="bg-primary-600 h-30 md:h-40 flex items-center md:justify-center">
  <i class="icon icon-person-circle text-white text-5xl pl-6 md:text-6.5xl pr-4 md:pr-5"></i>
  <div class="flex flex-col">
    <div class="text-white font-bold text-28px md:text-4xl">{{ name }}</div>
    <div class="text-white text-base md:text-md">{{ email }}</div>
  </div>
</div>
